import { FileText, Eye } from 'lucide-react';
import Illustration from '../../../components/ui/Illustration';
import illuTeleverser from '../../../assets/illustrations/fonctionnalites/televerser.svg?raw';

// Mode « Depuis un document » : dropzone + nom du sujet + nb questions + catégorie.
// L'état (file, label, …) reste chez le parent — le submit passe par le form parent.
export default function DocumentModeFields({
    file, fileRef, selectFile, onPreview, onClearFile, uploading,
    enrichmentTarget, label, setLabel,
    aiNbQuestions, setAiNbQuestions,
    categories, categoryId, setCategoryId,
}) {
    return (
        <div className="ms-config2">
            <div
                className={`mt-upload-dropzone ${file ? 'mt-upload-dropzone--has-file' : ''}`}
                onClick={() => !file && fileRef.current?.click()}
            >
                {file ? (
                    <div className="mt-upload-dropzone__file">
                        <FileText size={18} />
                        <span>{file.name} <small>({(file.size / 1048576).toFixed(1)} Mo)</small></span>
                        <button type="button" className="mt-upload-dropzone__preview" onClick={(e) => { e.stopPropagation(); onPreview(); }} title="Aperçu">
                            <Eye size={16} />
                        </button>
                        <button type="button" onClick={(e) => { e.stopPropagation(); onClearFile(); }}>×</button>
                    </div>
                ) : (
                    <div className="mt-upload-dropzone__empty">
                        <Illustration svg={illuTeleverser} color="#6d28d9" className="mt-upload-illu" />
                        <span>Glissez un document ici ou <strong>cliquez pour choisir</strong></span>
                        <small>PDF, DOCX, TXT, CSV, HTML, images — Max 10 Mo</small>
                    </div>
                )}
                <input
                    ref={fileRef}
                    type="file"
                    accept=".pdf,.docx,.txt,.csv,.html,.jpg,.jpeg,.png,.webp"
                    onChange={(e) => selectFile(e.target.files[0])}
                    disabled={uploading}
                    hidden
                />
            </div>
            <div className="ms-config2__fields">
                {!enrichmentTarget && (
                    <div className="ms-field">
                        <label className="ms-field__label">Nom du sujet</label>
                        <input type="text" placeholder="Nom du document par défaut" value={label} onChange={(e) => setLabel(e.target.value)} maxLength={100} disabled={uploading} />
                        <p className="ms-field__hint">Donnez un nom au sujet, ou laissez vide : le nom du document sera repris (modifiable ensuite).</p>
                    </div>
                )}
                <div className="ms-field-row">
                    <div className="ms-field">
                        <label className="ms-field__label">Questions</label>
                        <select value={aiNbQuestions} onChange={e => setAiNbQuestions(Number(e.target.value))} disabled={uploading} className="mt-upload-category-select">
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                    {categories.length > 0 && !enrichmentTarget && (
                        <div className="ms-field" style={{ flex: 1.4 }}>
                            <label className="ms-field__label">Cat&eacute;gorie</label>
                            <select value={categoryId} onChange={(e) => setCategoryId(e.target.value)} disabled={uploading} className="mt-upload-category-select">
                                <option value="">Sans cat&eacute;gorie</option>
                                {categories.map(c => <option key={c.id} value={c.id}>{c.label}</option>)}
                            </select>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
